(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIcd10DeleteController',CovidIcd10DeleteController);

    CovidIcd10DeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidIcd10'];

    function CovidIcd10DeleteController($uibModalInstance, entity, CovidIcd10) {
        var vm = this;

        vm.covidIcd10 = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidIcd10.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
